import React, {useRef, useState} from "react";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UI from "components/UI";
import UISelect from 'components/selectbox/UISelect';
import ModalPopup from "../../../../components/modal";

function ContentsContainer() {


	//초기 데이터 설정
	const rowCnt = useRef<string>("20");

	const [onOff1, setOnOff1] = useState(true);
	const [onOff2, setOnOff2] = useState(true);
	const [onOff3, setOnOff3] = useState(true);
	const [onOff4, setOnOff4] = useState(true);
	const [onOff5, setOnOff5] = useState(true);
	const [onOff6, setOnOff6] = useState(true);
	const [onOff7, setOnOff7] = useState(true);
	
	let sheetCols7 = useRef<any>([]);

	function numberDonAmt(evtParam){
		if(evtParam.Row.DON_AMT == null) return 0;
		let amt = evtParam.Row.DON_AMT;
		amt = amt/100000000;
		console.log(amt);
		return amt;
	}
	function numberSuppAmt(evtParam){
		if(evtParam.Row.SUPP_AMT == null) return 0;
		let amt = evtParam.Row.SUPP_AMT;
		amt = amt/100000000;
		return amt;
	}

	//====== 그리드 공통 부 START
	var ib1 = ib1||{};
	ib1 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			Def:{
				Row:{
					CanFormula: 1
				}
			},
			"Cols": [
				{"Header": "년도","Type": "Text","Name": "YEAR","RelWidth": 1,"Align": "Center" ,"CanEdit": "0", "FormulaRow": "합계"},
				{"Header": "출연기업수","Type": "Int","Name": "COMPANY","RelWidth": 1.2,"Align": "Right" ,"CanEdit": "0", "FormulaRow": "Sum"},
				{"Header": "출연금액(억원)","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0","Formula": numberDonAmt, "FormulaRow": "Sum"},
				{"Header": "지원금액(억원)","Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0","Formula": numberSuppAmt, "FormulaRow": "Sum"},
				{"Header": "지원 중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0", "FormulaRow": "Sum"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				doSearch('1');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet1', // 생성할 시트의 id
				el: 'sheetDiv1', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");			

			//@ts-ignore
			IBSheet.sheet11.down2Excel({fileName: "연도별 현황(누적)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}	
	//====== 그리드 공통 부 START
	var ib11 = ib11||{};
	ib11 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},

			"Cols": [
				{"Header": "년도","Type": "Text","Name": "YEAR","RelWidth": 1,"Align": "Center" ,"CanEdit": "0", "FormulaRow": "합계"},
				{"Header": "출연기업수","Type": "Int","Name": "COMPANY","RelWidth": 1.2,"Align": "Right" ,"CanEdit": "0", "FormulaRow": "Sum"},
				{"Header": "출연금액(억원)","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0","FormulaRow": "Sum"},
				{"Header": "지원금액(억원)","Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0", "FormulaRow": "Sum"},
				{"Header": "지원 중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0", "FormulaRow": "Sum"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet11', // 생성할 시트의 id
				el: 'sheetDiv11', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");			

			//@ts-ignore
			IBSheet.sheet11.down2Excel({fileName: "연도별 현황(누적)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib2 = ib2||{};
	ib2 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "250px"

			},
			"Cols": [
				{"Header": "순위","Type": "Text","Name": "RN","RelWidth": 0.3,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "출연액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('2');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet2', // 생성할 시트의 id
				el: 'sheetDiv2', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib3 = ib3||{};
	ib3 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "250px"

			},
			"Cols": [
				{"Header": "순위","Type": "Text","Name": "RN","RelWidth": 0.3,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "출연액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet3', // 생성할 시트의 id
				el: 'sheetDiv3', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib4 = ib4||{};
	ib4 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "사업명","Type": "Text","Name": "BIZ_NM","RelWidth": 1.5,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "약칭","Type": "Text","Name": "BIZ_NM2","RelWidth": 1.5,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "출연기업수","Type": "Int","Name": "COMPANY","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "출연액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "현황","Type": "Text","Name": "STATUS","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet4', // 생성할 시트의 id
				el: 'sheetDiv4', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet4.down2Excel({fileName: "출연사업별 현황(누적)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib5 = ib5||{};
	ib5 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "700px"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "기금사용용도(상생법)","Type": "Text","Name": "NM","RelWidth": 1.5,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원 중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet5', // 생성할 시트의 id
				el: 'sheetDiv5', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부 START
	var ib6 = ib6||{};
	ib6 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "700px"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.6,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "사업분야","Type": "Text","Name": "NM","RelWidth": 1.6,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet6', // 생성할 시트의 id
				el: 'sheetDiv6', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부 START
	var ib7 = ib7||{};
	ib7 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.6,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "사업분야","Type": "Text","Name": "NM","RelWidth": 1.6,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			sheetCols7.current = [
				{"Header": "성과지표","Type": "Text","Name": "NM","RelWidth": 0.5,"Align": "Center","CanEdit": "0"},
			];

			options.Cols = sheetCols7.current;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet7', // 생성할 시트의 id
				el: 'sheetDiv7', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}



	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(actionId:string) {
		let param:any = {};
		let url = 'adm_8100';


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url: url,
			data: param
		})



		//전체데이터
		let result = response;

		console.log(result);

		//데이터 처리
		ib1.data = result.REC1;
		// @ts-ignore
		sheet1.loadSearchData (result.REC1);  //data 로딩 처리
		// @ts-ignore
		sheet1.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet1.reloadData();
		//@ts-ignore
		sheet1.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
		//데이터 처리
		ib11.data = result.REC1;
		// @ts-ignore
		sheet11.loadSearchData (result.REC1);  //data 로딩 처리
		// @ts-ignore
		sheet11.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet11.reloadData();
		//@ts-ignore
		sheet11.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib2.data = result.REC2;
		// @ts-ignore
		sheet2.loadSearchData (result.REC2);  //data 로딩 처리
		// @ts-ignore
		sheet2.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet2.reloadData();
		//@ts-ignore
		sheet2.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib3.data = result.REC3;
		// @ts-ignore
		sheet3.loadSearchData (result.REC3);  //data 로딩 처리
		// @ts-ignore
		sheet3.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet3.reloadData();
		// @ts-ignore
		sheet3.rerender(1); //최종 수정된 내용을 화면에 반영한다.		

		//데이터 처리
		ib4.data = result.REC4;
		// @ts-ignore
		sheet4.loadSearchData (result.REC4);  //data 로딩 처리
		// @ts-ignore
		sheet4.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet4.reloadData();
		// @ts-ignore
		sheet4.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
		//데이터 처리
		ib5.data = result.REC5;
		// @ts-ignore
		sheet5.loadSearchData (result.REC5);  //data 로딩 처리
		// @ts-ignore
		sheet5.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet5.reloadData();
		// @ts-ignore
		sheet5.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib6.data = result.REC6;
		// @ts-ignore
		sheet6.loadSearchData (result.REC6);  //data 로딩 처리
		// @ts-ignore
		sheet6.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet6.reloadData();
		// @ts-ignore
		sheet6.rerender(1); //최종 수정된 내용을 화면에 반영한다.


		let newList:any = [];
		if(result.REC7.length != 0){
			let arr:any = {};
			arr["NM"] = "합계";
			for(let i = 0; i < result.REC7.length; i++){
				arr[result.REC7[i].QUA_TEXT] = result.REC7[i].QUA_REG_CNT;
				// @ts-ignore
				sheet7.addCol( result.REC7[i].QUA_TEXT, 1, -1, {"Header": result.REC7[i].QUA_TEXT,"Type": "Int", "RelWidth": 1,"Align": "Right","CanEdit": "0"}, true, false );
			}
			// @ts-ignore
			newList.push(arr);
		}

		
		//데이터 처리
		ib7.data = newList;


		// @ts-ignore
		sheet7.loadSearchData (newList);  //data 로딩 처리
		// @ts-ignore
		sheet7.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet7.reloadData();
		// @ts-ignore
		sheet7.rerender(); //최종 수정된 내용을 화면에 반영한다.


	}

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib1.create();
		ib11.create();
		ib2.create();
		ib3.create();
		ib4.create();
		ib5.create();
		ib6.create();
		ib7.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	function isOpen(type, num){
		let first = 0;
		let other = 1;
		if(type == 'close'){
			first = 1;
			other = 0;
		}

		if(num == '1'){
			//@ts-ignore
			sheet1.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet1.renderBody();
		}else if(num == '2'){
			//@ts-ignore
			sheet2.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet2.renderBody();
		}else if(num == '3'){
			//@ts-ignore
			sheet3.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet3.renderBody();
		}else if(num == '4'){
			//@ts-ignore
			sheet4.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet4.renderBody();
		}else if(num == '5'){
			//@ts-ignore
			sheet5.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet5.renderBody();
		}else if(num == '6'){
			//@ts-ignore
			sheet6.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet6.renderBody();
		}else if(num == '7'){
			//@ts-ignore
			sheet7.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet7.renderBody();
		}

		//true -> 펼친상태 / type -> close 접으려는 상태
		//false -> 접힌상태 / type -> open 펼치려는 상태
		if(num == '2'){
			if(type == 'close' && onOff3 == false){
				$('#sheetDiv2').css('height', '100px')
				$('#sheetDiv3').css('height', '100px')
			}else{
				$('#sheetDiv2').css('height', '250px')
				$('#sheetDiv3').css('height', '250px')
			}
		}
		if(num == '3'){
			if(type == 'close' && onOff2 == false){
				$('#sheetDiv2').css('height', '100px')
				$('#sheetDiv3').css('height', '100px')
			}else{
				$('#sheetDiv2').css('height', '250px')
				$('#sheetDiv3').css('height', '250px')
			}
		}

		if(num == '5'){
			if(type == 'close' && onOff6 == false){
				$('#sheetDiv5').css('height', '100px')
				$('#sheetDiv6').css('height', '100px')
			}else{
				$('#sheetDiv5').css('height', '700px')
				$('#sheetDiv6').css('height', '700px')
			}
		}
		if(num == '6'){
			if(type == 'close' && onOff5 == false){
				$('#sheetDiv5').css('height', '100px')
				$('#sheetDiv6').css('height', '100px')
			}else{
				$('#sheetDiv5').css('height', '700px')
				$('#sheetDiv6').css('height', '700px')
			}
		}



	}

	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">보고서</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">누적 현황통계</h1>
					<div className="hz-root hz-sb mb10">
						<h3 className="section-title">연도별 현황(누적)</h3>
						<div className="hz-item hz-root hz-gap5">
							{ onOff1 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '1'); setOnOff1(false); } }>접기</Button> }
							{ onOff1 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '1'); setOnOff1(true); } }>펼치기</Button> }
							<Button color="gray-o" size="sm" onClick={()=> ib1.exportData()}>다운로드</Button>
						</div>
					</div>
					<div id={'sheetDiv1'} className="ibsheet mb40">[D] IBSHEET 영역</div>
					<div style={ { display:"none" } } id={'sheetDiv11'} className="ibsheet mb40">[D] IBSHEET 영역</div>


					<div className="pt">
						<div className="row">
							<div className="col col-5 mr15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">상위출연 민간기업</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff2 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '2'); setOnOff2(false); } }>접기</Button> }
										{ onOff2 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '2'); setOnOff2(true); } }>펼치기</Button> }
									</div>
								</div>
								<div id={'sheetDiv2'}  className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
							<div className="col col-5 ml15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">상위출연 공공기관</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff3 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '3'); setOnOff3(false); } }>접기</Button> }
										{ onOff3 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '3'); setOnOff3(true); } }>펼치기</Button> }
									</div>
								</div>		
								<div id={'sheetDiv3'}  className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
						</div>
					</div>					

					<div className="hz-root hz-sb mb10">
						<h3 className="section-title">출연사업별 현황(누적)</h3>
						<div className="hz-item hz-root hz-gap5">
							{ onOff4 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '4'); setOnOff4(false); } }>접기</Button> }
							{ onOff4 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '4'); setOnOff4(true); } }>펼치기</Button> }
							<Button color="gray-o" size="sm" onClick={()=> ib4.exportData()}>다운로드</Button>
						</div>
					</div>			
					<div id={'sheetDiv4'} className="ibsheet mb40">[D] IBSHEET 영역</div>

					<div className="pt">
						<div className="row">
							<div className="col col-5 mr15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">기금사용용도(상생법)</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff5 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '5'); setOnOff5(false); } }>접기</Button> }
										{ onOff5 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '5'); setOnOff5(true); } }>펼치기</Button> }
									</div>
								</div>			
								<div id={'sheetDiv5'} className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
							<div className="col col-5 ml15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">사업분야</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff6 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '6'); setOnOff6(false); } }>접기</Button> }
										{ onOff6 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '6'); setOnOff6(true); } }>펼치기</Button> }
									</div>
								</div>			
								<div id={'sheetDiv6'} className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
						</div>
					</div>					

					<div className="hz-root hz-sb mb10">
						<h3 className="section-title">주요성과</h3>
					</div>		
					<div id={'sheetDiv7'} className="ibsheet mb40">[D] IBSHEET 영역</div>

				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;